import {asyncRouterMap, constantRouterMap} from '@/router'
// import Layout from '@/views/frame/Layout.vue'
// import MainIndex from '@/views/mainIndex.vue'
import {get} from '@/api/bizApi/commonUtil'
import {routerData} from '@/mock/data.js' 

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    searchRoute: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.routers = [...constantRouterMap.concat(routers)]
      state.addRouters = [...routers]
    },
    SEARCH_ROUTE: (state, data) => {
      state.searchRoute = data
    }
  },
  actions: {
    // 根据服务端菜单生成路由
    GenerateRoutes ({commit}, data) {
      return new Promise(resolve => {
        const { roles } = data
        let accessedRouters
        if (roles.indexOf('admin') >= 0) {
          // accessedRouters = asyncRouterMap
          // get('/getRouter').then(res => {
          //   accessedRouters = res.data
          //   commit('SET_ROUTERS', accessedRouters);
          //   resolve();
          // })
          accessedRouters = genarateAsyncRouter(routerData)
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        commit('SET_ROUTERS', accessedRouters);
        resolve();
        
      })
    }
  }
}
export default permission
// 数据说明
/* {
  url: 路径,
  redirect: 重定向,
  name: 名称,
  icon: 图标,
  componentURL: 组件路径
  level: 节点级别(无根路径)，parent-一级节点，subNode-非一级树节点, leaf-叶子节点
} */
/* 路由模板 */
const rout = {
  template: '<router-view></router-view>'
}
function genarateAsyncRouter (menus) {
 if(menus && menus.length > 0) {
    for (let menu of menus) {
      if(menu.children && menu.children.length > 0) {
        if (menu.level == 'parent') {
          //menu.component = resolve => require(['@/views/frame/Layout.vue'], resolve) 
        } else if (menu.level == 'subNode') {
          menu.component = rout
        }
        menu.children = genarateAsyncRouter(menu.children)
      } else {
       // menu.component = resolve => require(['@/views/bizViews'+ menu.componentURL + '.vue'], resolve) 
      }
    }
  } 
  return menus
}
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(role => route.meta.role.indexOf(role) >= 0)
  } else {
    return true
  }
}
function filterAsyncRouter(asyncRouterMap, roles) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/gtn/store/modules/permission.js